import { config } from '../../src/config';

function useDomain() {
  //   let hasSubDomain = false;
  //   const siteURL = config.siteURL;
  //   const urlPath = window.location.host.split(siteURL);

  //   if (urlPath[0] !== '') {
  //     hasSubDomain = true;
  //   }

  //   return [hasSubDomain];

  try {
    const url = window?.location?.host;
    const host = checkWWW(url);
    const siteURL = config.siteURL;
    let hasSubDomain = false;
    if (host == siteURL) {
      hasSubDomain = false;
    } else {
      hasSubDomain = true;
    }
    return [hasSubDomain];

    // const domains = host?.split('.');
    // const initialDomain = domains.find(
    //   (element) => element == config.siteURL.split('.')[0]
    // );
    // if (initialDomain) {
    //   const subdomain = host?.split('.')[0];
    //   return subdomain;
    // } else {
    //   return host;
    // }
  } catch (error) {
    console.log(error);
  }
}

export default useDomain;

const checkWWW = (host) => {
  const domains = host?.split('.');
  //const domains = ['www', 'bbn', 'localhost:3001', 'com'];
  const www = domains.shift();
  if (www === 'www') {
    //console.log('We found www in url. Removing WWW..');
    let customDomain = '';
    domains.map((element, index) => {
      const dot = index == 0 ? '' : '.';
      customDomain = customDomain + dot + `${element}`;
    });
    return customDomain;
  } else {
    return host;
  }
};
